import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ColorScale from '_class/ColorScale';
import DateTime from '_class/DateTime';
import { useTranslate } from 'lib/translate';
import { capitalize } from 'helpers/content';
import { getUserSummary, getUserStatisticsDetailed } from 'actions/assessments';
import DisplayMatrix from 'components/Presentation/DisplayMatrix';
import DisplayGoal from 'components/Presentation/DisplayGoal';
import DisplayFeedbacks from 'components/Presentation/DisplayFeedbacks';
import { Spinner } from 'UI';
import { Bar } from 'UI/Graphs';
import { Expandable, Icon } from '@haldor/ui';
import User from '_class/User';

var VerdictAssessmentsDisplay = function VerdictAssessmentsDisplay(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var dispatch = useDispatch();
  var summary = useSelector(function (state) {
    var _state$assessments;

    return (_state$assessments = state.assessments) === null || _state$assessments === void 0 ? void 0 : _state$assessments.studentOverview;
  });
  var statistics = useSelector(function (state) {
    var _state$assessments2;

    return (_state$assessments2 = state.assessments) === null || _state$assessments2 === void 0 ? void 0 : _state$assessments2.studentStatistics;
  });
  var currentUser = useSelector(function (state) {
    return state.user.currentUser;
  });
  var user = new User(currentUser);
  var translate = useTranslate();
  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.next = 3;
            return Promise.all([dispatch(getUserSummary(props.studentId, props.start, props.end)), dispatch(getUserStatisticsDetailed(props.studentId, props.start, props.end))]);

          case 3:
            setLoading(false);
            return _context.abrupt("return", function () {
              return null;
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [props.studentId, props.start, props.end, props.sectionId]);

  var getGoals = function getGoals() {
    if (summary == null) {
      return [];
    }

    var goals = [];
    summary.assessmentGoals.forEach(function (goal) {
      var _summary$assessmentBl;

      var parts = (_summary$assessmentBl = summary.assessmentBlockParts) === null || _summary$assessmentBl === void 0 ? void 0 : _summary$assessmentBl.filter(function (part) {
        return part.referenceType == 'assessmentGoal' && part.referenceId == goal.id && part.assessmentBlockPartRelationships.find(function (relation) {
          return relation.courseId == props.courseId;
        }) != null;
      });
      goals.push(_objectSpread({
        parts: parts
      }, goal));
    });
    return goals;
  };

  var getMatrices = function getMatrices() {
    if (summary == null) {
      return [];
    }

    var matrices = [];
    summary.courses.forEach(function (course) {
      course.details.forEach(function (detail) {
        var _summary$assessmentBl2;

        var parts = (_summary$assessmentBl2 = summary.assessmentBlockParts) === null || _summary$assessmentBl2 === void 0 ? void 0 : _summary$assessmentBl2.filter(function (part) {
          return part.referenceType == 'matrix' && part.referenceId == detail.matrixID && part.assessmentBlockPartRelationships.find(function (relation) {
            return relation.courseId == props.courseId;
          }) != null;
        });

        if (parts.length > 0) {
          matrices.push({
            id: detail.matrix.id,
            disableNotAchieved: detail.matrix.disableNotAchieved,
            '_ParagraphSet': detail.matrix['_ParagraphSet'],
            color: course.colorCode,
            parts: parts
          });
        }
      });
    });
    return matrices;
  };
  /**
   * @param {array} parts
   * @returns {array} feedbacks
   */


  var getFeedbacksForParts = function getFeedbacksForParts(parts) {
    if (summary == null) {
      return [];
    }

    return JSON.parse(JSON.stringify(summary.assessmentFeedbacks)).filter(function (feedback) {
      return parts.find(function (part) {
        return feedback.assessmentBlockPartId == part.id && part.assessmentBlockPartRelationships.find(function (relation) {
          return relation.courseId == props.courseId;
        }) != null;
      }) != null;
    });
  };
  /**
   * @returns {object} statistic
   */


  var getStudentStatistic = function getStudentStatistic() {
    if (statistics == null || props.studentId == null) {
      return null;
    }

    return statistics.find(function (statistic) {
      return statistic.studentId == props.studentId;
    });
  };
  /**
   * @param {number} goalId
   * @returns {object} statistic
   */


  var getGoalStatistic = function getGoalStatistic(goalId) {
    var _getStudentStatistic, _getStudentStatistic$;

    return (_getStudentStatistic = getStudentStatistic()) === null || _getStudentStatistic === void 0 ? void 0 : (_getStudentStatistic$ = _getStudentStatistic.studentStatistics) === null || _getStudentStatistic$ === void 0 ? void 0 : _getStudentStatistic$.find(function (statistic) {
      return statistic.type == 'ASSESSMENTGOAL' && statistic.referenceId == goalId;
    });
  };
  /**
   * @param {number} matrixId 
   * @returns {object} statistic
   */


  var getMatrixStatistic = function getMatrixStatistic(matrixId) {
    var _getStudentStatistic2, _getStudentStatistic3;

    return (_getStudentStatistic2 = getStudentStatistic()) === null || _getStudentStatistic2 === void 0 ? void 0 : (_getStudentStatistic3 = _getStudentStatistic2.studentStatistics) === null || _getStudentStatistic3 === void 0 ? void 0 : _getStudentStatistic3.find(function (statistic) {
      return statistic.type == 'MATRIX' && statistic.referenceId == matrixId;
    });
  };

  var getPartTitle = function getPartTitle(type, statistic, reference) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var colors = [];

    if (statistic != null) {
      var addRed = false;

      if (statistic.type == "MATRIX") {
        addRed = !reference.disableNotAchieved;
      }

      if (statistic.type == "ASSESSMENTGOAL") {
        addRed = reference.rows.find(function (row) {
          return row.cells.find(function (cell) {
            return cell.type == 'NotAchievedTextField';
          });
        }) != null;
      }

      colors = new ColorScale(statistic.statistics.length).get(addRed);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "df aic bar-outer-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bar-title-container"
    }, translate(type), type == 'assessmentGoal' ? ' ' + index : null), statistic != null ? /*#__PURE__*/React.createElement(Bar, {
      data: statistic.statistics.map(function (stat) {
        return {
          amount: stat.count,
          label: stat.count,
          color: colors[stat.index]
        };
      }),
      showAmount: true,
      showAllSteps: true
    }) : null);
  };
  /**
   * @param {string} target
   * @param {array} permissions
   */


  var renderPermission = function renderPermission(target, permissions) {
    var active = permissions.find(function (perm) {
      return perm.target == target;
    }) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize(target)));
  };
  /**
   * @param {object} feedback
   * @param {number} index
   */


  var renderFeedback = function renderFeedback(feedback, index) {
    var _summary$assessmentBl3;

    var resource = summary === null || summary === void 0 ? void 0 : (_summary$assessmentBl3 = summary.assessmentBlockParts) === null || _summary$assessmentBl3 === void 0 ? void 0 : _summary$assessmentBl3.find(function (part) {
      return part.id == feedback.assessmentBlockPartId;
    });
    var permissions = [];

    if (resource != null && !feedback.isPrivate) {
      permissions = resource.permissions;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "feedback",
      style: {
        paddingLeft: 0
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "df jcb aic size-12",
      style: {
        marginBottom: '.4rem'
      }
    }, /*#__PURE__*/React.createElement("div", null, feedback.navigationObject != null ? feedback.navigationObject.referenceType == 'PLAN' ? translate('Plan') : translate('Assignment') + ' • ' + feedback.navigationObject.title : null), /*#__PURE__*/React.createElement("div", null, feedback.editorUser.firstName, " ", feedback.editorUser.lastName, ' • ' + new DateTime(feedback.created).getLongDate())), /*#__PURE__*/React.createElement("div", {
      className: "df jcb ais"
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: feedback.text
      }
    }), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
      className: "permissions"
    }, renderPermission('STUDENT', permissions), renderPermission('GUARDIAN', permissions)) : null));
  };
  /**
   * @param {array} goals 
   * @param {array} matrices 
   * @param {boolean} isPrivate
   */


  var renderCollected = function renderCollected() {
    var goals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var matrices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isPrivate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return /*#__PURE__*/React.createElement("div", {
      className: "course-content"
    }, goals.map(function (goal, index) {
      var feedbacks = getFeedbacksForParts(goal.parts).filter(function (feedback) {
        return feedback.isPrivate == isPrivate;
      });

      if (feedbacks.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        key: goal.id,
        title: getPartTitle('assessmentGoal', null, goal, index + 1)
      }, /*#__PURE__*/React.createElement("div", {
        className: "display-feedbacks",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, feedbacks.map(renderFeedback)));
    }), matrices.map(function (matrix) {
      var feedbacks = getFeedbacksForParts(matrix.parts).filter(function (feedback) {
        return feedback.isPrivate == isPrivate;
      });

      if (feedbacks.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        key: matrix.id,
        title: getPartTitle('matrix', null, matrix)
      }, /*#__PURE__*/React.createElement("div", {
        className: "display-feedbacks",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, feedbacks.map(renderFeedback)));
    }));
  };

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "user-asessments assessment-block"
    }, /*#__PURE__*/React.createElement(Spinner, {
      center: true
    }));
  }

  var goals = getGoals();
  var matrices = getMatrices();
  var title = /*#__PURE__*/React.createElement("div", {
    className: "df aic"
  }, /*#__PURE__*/React.createElement("span", null, translate('Assessments')), /*#__PURE__*/React.createElement("div", {
    className: "size-14 color--meta",
    style: {
      marginLeft: '.75rem'
    }
  }, new DateTime(props.start).getDateStamp(), " - ", new DateTime(props.end).getDateStamp()));
  return /*#__PURE__*/React.createElement("div", {
    className: "user-assessments assessment-block"
  }, /*#__PURE__*/React.createElement(Expandable, {
    title: title
  }, /*#__PURE__*/React.createElement("div", {
    className: "course-content"
  }, props.showGoals ? goals.map(function (goal, index) {
    var statistic = getGoalStatistic(goal.id);
    var feedbacks = getFeedbacksForParts(goal.parts);
    return /*#__PURE__*/React.createElement(Expandable, {
      key: goal.id,
      title: getPartTitle('assessmentGoal', statistic, goal, index + 1)
    }, /*#__PURE__*/React.createElement(DisplayGoal, {
      goal: goal,
      statistic: statistic
    }), feedbacks.length > 0 ? /*#__PURE__*/React.createElement(DisplayFeedbacks, {
      feedbacks: feedbacks
    }) : null);
  }) : null, props.showMatrices ? matrices.map(function (matrix) {
    var statistic = getMatrixStatistic(matrix.id);
    var feedbacks = getFeedbacksForParts(matrix.parts);
    return /*#__PURE__*/React.createElement(Expandable, {
      key: matrix.id,
      title: getPartTitle('matrix', statistic, matrix)
    }, /*#__PURE__*/React.createElement(DisplayMatrix, {
      matrix: matrix,
      statistic: statistic
    }), feedbacks.length > 0 ? /*#__PURE__*/React.createElement(DisplayFeedbacks, {
      feedbacks: feedbacks
    }) : null);
  }) : null)), /*#__PURE__*/React.createElement(Expandable, {
    title: translate('Collected feedback')
  }, renderCollected(goals, matrices, false)), /*#__PURE__*/React.createElement(Expandable, {
    title: translate('Personal notes')
  }, renderCollected(goals, matrices, true)));
};

VerdictAssessmentsDisplay.defaultProps = {
  showGoals: true,
  showMatrices: true
};
export default VerdictAssessmentsDisplay;